export const ROUTES = {
  DASHBOARD: '/',
  NOT_FOUND: '/404',
  AUTH_PHONE: '/auth/phone',
  AUTH_CODE: '/auth/code',
  AUTH_IMPERSONATE: '/auth/impersonate',
  SERVICES: '/services',
  EMPLOYEES: '/employees',
  SHIFT_EDIT: '/shifts/:uuid/edit',
  EMPLOYEE_NEW: '/employees/new',
  EMPLOYEE_EDIT: '/employees/:uuid',
  PAYMENT_SCHEME_TEMPLATE_NEW: '/settings/payment-scheme-templates/new',
  PAYMENT_SCHEME_TEMPLATE_EDIT: '/settings/payment-scheme-templates/:uuid',
  SHIFT_TEMPLATE_NEW: '/settings/shift-templates/new',
  SHIFT_TEMPLATE_EDIT: '/settings/shift-templates/:uuid',
  ORDERS: '/orders',
  ANALYTICS: '/analytics',
  SCHEDULE: '/schedule',
  SCHEDULE_EDIT: '/schedule/edit',
  SETTINGS: '/settings',
  NOTIFICATIONS: '/notifications',
  PAYMENT_MOCK: '/payment-mock/:bookingUuid',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RouteValue = (typeof ROUTES)[RouteKey];